import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from "../../services/local-storage.service";
import {ToastMessagesService} from "../../services/toast-messages.service";
import {CommonService} from "../../services/common.service";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {SwPush} from "@angular/service-worker";
import {NotificationService} from "../../services/notification.service";
import {ApplicationFeature} from "../../models/applicationFeature";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  currentUser: any;
  applicationFeatures: ApplicationFeature[] = [];
  loadingFeatures: boolean;
  children: any;
  loadingChildren: boolean;
  consents = [];
  notifications: any;
  loadingNotifications: boolean;

  loadingCompletedConsents: boolean;
  completedConsents: any[];
  notificationTitle: string;

  allNotifications: any[];

  constructor(private localStorageService: LocalStorageService, public toastMessagesService: ToastMessagesService,
              private commonService: CommonService, public dialog: MatDialog,
              public router: Router, public swPush: SwPush, private notificationService: NotificationService) {

    this.currentUser = JSON.parse(this.localStorageService.get('user'));

    this.notifications = [];
    this.completedConsents = [];
    this.children = [];
  }

  async ngOnInit() {
    this.loadingChildren = true;
    this.loadingFeatures = true;
    this.loadingNotifications = true;
    this.loadingCompletedConsents = true;

    await this.initializeFeatures();
    await this.initNotifications(false);

    // if User belongs to role parent -- must implement
    await this.initializeChildren();

    await this.initializeCompletedConsents();

    this.swPush.messages.subscribe(async (message) => {
      this.toastMessagesService.toastMessages(`Έχετε ειδοποιήσεις`);
      await this.initNotifications(true);
    });
  }

//#region Requests
  async initNotifications(force: boolean) {
    try {
      // const notificationRequest = await this.commonService.getList(`people/parents/notifications?parentId=${this.currentUser.id}`);
      await this.notificationService.getAllNotifications(+this.currentUser.id, force);

      this.notifications = this.notificationService.getInCompleteNotifications();
      console.log(`Current notifications`);
      console.log(this.notifications);
      this.notificationTitle = this.notifications.length === 0 ? 'Δεν έχετε εκκρεμείς αιτήσεις' : `Έχετε εκκρεμείς αιτήσεις`;
    } catch (e) {
      console.log(e);
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingNotifications = false;
    }
  }

  async initializeFeatures() {
    try {
      const featureRequest = await this.commonService.getList('features');
      this.applicationFeatures = featureRequest.object;
    } catch (e) {
      console.log(e.message);
    } finally {
      this.loadingFeatures = false;
    }
  }

  async initializeChildren() {
    try {
      const childrenRequest = await this.commonService.getList(`children?parentId=${this.currentUser.id}`);
      this.children = childrenRequest.object;
      for (const child of this.children) {
        child.notifications = [];
        const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
        for (const consent of filteredConsents) {
          const notificationModel = {
            id: consent.id,
            formId: consent.formId,
            title: consent.formTitle,
            subTitle: consent.deadline ? consent.deadline : '-',
            deadline : consent.deadline ? consent.deadline : '-',
            content: 'Ενημέρωση και συγκατάθεση ως προς τη συλλογή και επεξεργασία προσωπικών στοιχείων του παιδιού μου',
            mode: consent.mode
          };
          child.notifications.push(notificationModel);
        }
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      this.loadingChildren = false;
      console.log(this.children);
    }
  }

  async initializeCompletedConsents() {
    try {
      this.completedConsents = [];
      this.completedConsents = this.notificationService.getCompletedNotifications();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingCompletedConsents = false;
    }
  }


  showNotificationToChild(child: any) {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    return filteredConsents.length === 0;
  }


  childNotification(child: any) {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    return filteredConsents.length;
  }

  notificationMessage(child: any): string {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    if(filteredConsents.length === 0) {
      return 'Ειδοποιήσεις'
    } else if (filteredConsents.length === 1) {
      return 'Ειδοποίηση'
    } else {
      return 'Ειδοποιήσεις'
    }
  }
}
